import { render, staticRenderFns } from "./BusinessCreditsReport.vue?vue&type=template&id=b4586014&"
import script from "./BusinessCreditsReport.vue?vue&type=script&lang=js&"
export * from "./BusinessCreditsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports